import React, { useEffect, useRef, useState } from 'react';
import journeyImg2010 from '../image/images (3).jpg';
import journeyImg2013 from '../image/i7.jpg';
import journeyImg2015 from '../image/i8.webp';
import journeyImg2017 from '../image/i10.webp';

export default function Journey() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );
  const sectionRef = useRef(null);

  // Keep layout in sync on resize/orientation change (fixes stale window.innerWidth reads)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 576;

  const journeys = [
    { year: '2010', title: '1st International Veteran Athletics Championship', location: 'Balewadi, Pune', medals: ['100 m Run - Silver', 'Long Jump - Silver', 'Triple Jump - Silver'], badgeBg: '#198754', img: journeyImg2010 },
    { year: '2013', title: 'World Masters Games', location: 'Torino, Italy', medals: ['Triple Jump - Silver', 'Long Jump - Bronze', '4 x 400 m Relay - Bronze'], badgeBg: '#0d6efd', img: journeyImg2013 },
    { year: '2015', title: 'Australian Masters Games', location: 'Australia', medals: ['60 m Run - Silver', '100 m Run - Silver', 'Long Jump - Gold', 'Triple Jump - Gold'], badgeBg: '#fd7e14', img: journeyImg2015 },
    { year: '2017', title: 'World Masters Games', location: 'Auckland, New Zealand', medals: ['Triple Jump - Silver'], note: 'Won Silver Medal after major accident.', badgeBg: '#6f42c1', img: journeyImg2017 },
  ];

  // Intersection Observer
  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) observer.disconnect();
    };
  }, []);

  // Auto-Slide Effect
  useEffect(() => {
    if (!isVisible || isHovered) return;

    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % journeys.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [isVisible, isHovered, journeys.length]);

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % journeys.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + journeys.length) % journeys.length);
  };

  return (
    <section ref={sectionRef} id="journey" style={styles.journeySection} className="py-4 py-lg-5">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Poppins:wght@400;500;600;700;800&display=swap');

        .journey-scroll-hidden {
          opacity: 0;
          transform: translateY(-40px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }
        .journey-scroll-visible {
          opacity: 1;
          transform: translateY(0);
        }

        /* 3D Cover Flow Wrapper */
        .coverflow-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          min-height: 460px;
          perspective: 1000px;
          overflow: hidden;
        }

        .coverflow-container {
          position: relative;
          width: 100%;
          max-width: 1200px;
          height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .coverflow-item {
          position: absolute;
          width: 340px;
          transition: all 0.5s cubic-bezier(0.25, 1, 0.5, 1);
          cursor: pointer;
          user-select: none;
        }

        /* Journey Card Professional Styling */
        .journey-card-inner {
          transition: box-shadow 0.4s ease, border-color 0.4s ease;
          border: 2px solid transparent;
        }

        .coverflow-item.is-active .journey-card-inner {
          border-color: rgba(255, 119, 0, 0.35);
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18), 0 0 0 6px rgba(255, 119, 0, 0.08) !important;
        }

        .journey-img-wrapper {
          position: relative;
          overflow: hidden;
        }

        .journey-img-wrapper::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.35) 100%);
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .coverflow-item.is-active .journey-img-wrapper::after {
          opacity: 1;
        }

        .journey-card-img {
          transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
        }

        .coverflow-item.is-active .journey-card-img {
          transform: scale(1.08);
        }

        .year-badge-anim {
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.4s ease;
        }

        .coverflow-item.is-active .year-badge-anim {
          transform: translateX(-50%) scale(1.12);
          box-shadow: 0 6px 14px rgba(0,0,0,0.25);
        }

        /* Nav Buttons Styling */
        .nav-btn {
          background: #ffffff;
          border: 2px solid #ff7700;
          color: #ff7700;
          min-width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
          z-index: 20;
          transition: all 0.2s ease;
          outline: none;
        }

        .nav-btn:hover {
          background: #ff7700;
          color: #ffffff;
          transform: scale(1.08);
        }

        @media (max-width: 992px) {
          .coverflow-item {
            width: 280px;
          }
        }

        @media (max-width: 768px) {
          .coverflow-item {
            width: 230px;
          }
        }

        @media (max-width: 575.98px) {
          .coverflow-container {
            height: 380px;
          }
          .nav-btn { 
            min-width: 32px;
            height: 32px;
          }
        }

        /* Mobile / touch devices: flat icon-only arrows, no border or hover circle */
        @media (hover: none) {
          .nav-btn {
            background: transparent;
            border: none;
            box-shadow: none;
          }
          .nav-btn:hover,
          .nav-btn:active {
            background: transparent;
            color: #ff7700;
            transform: none;
            box-shadow: none;
          }
        }
      `}</style>

      <div className={`container-fluid px-3 px-md-5 py-2 py-lg-3 journey-scroll-hidden ${isVisible ? 'journey-scroll-visible' : ''}`}>
        {/* Section Heading */}
        <div className="d-flex align-items-center justify-content-center mb-4">
          <div style={styles.headingLineLeft}></div>
          <h5 style={styles.sectionHeading}>CAREER JOURNEY</h5>
          <div style={styles.headingLineRight}></div>
        </div>

        {/* 3D Cover Flow Layout */}
        <div 
          className="coverflow-wrapper"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Left Arrow Button */}
          <button 
            className="nav-btn me-2 me-md-3" 
            onClick={handlePrev}
            aria-label="Previous Slide"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>

          {/* Cover Flow Items Container */}
          <div className="coverflow-container">
            {journeys.map((item, idx) => {
              const total = journeys.length;
              let diff = idx - activeIndex;

              // Infinite Circular Loop logic
              if (diff > total / 2) {
                diff -= total;
              } else if (diff < -total / 2) {
                diff += total;
              }

              const absDiff = Math.abs(diff);
              const spacing = windowWidth < 576 ? 180 : windowWidth < 992 ? 260 : 320;

              // On phones, skip the 3D peek entirely: only the active card is shown,
              // centered, with a simple fade — no side cards sliding in from left/right.
              const xOffset = isMobile ? 0 : diff * spacing;
              const rotateY = isMobile ? 0 : diff === 0 ? 0 : diff > 0 ? -35 : 35;
              const scale = isMobile ? 1 : diff === 0 ? 1 : Math.max(0.78, 1 - absDiff * 0.12);
              const zIndex = 10 - absDiff;
              const opacity = isMobile
                ? (diff === 0 ? 1 : 0)
                : absDiff > 1.5 ? 0 : diff === 0 ? 1 : 0.75;

              return (
                <div
                  key={idx}
                  className={`coverflow-item ${diff === 0 ? 'is-active' : ''}`}
                  onClick={() => setActiveIndex(idx)}
                  style={{
                    transform: `translateX(${xOffset}px) scale(${scale}) rotateY(${rotateY}deg)`,
                    zIndex: zIndex,
                    opacity: opacity,
                    pointerEvents: isMobile && diff !== 0 ? 'none' : 'auto',
                    filter: diff === 0 ? 'none' : 'brightness(0.9)',
                  }}
                >
                  <span className="year-badge-anim" style={{ ...styles.yearBadge, backgroundColor: item.badgeBg }}>{item.year}</span>
                  <div className="journey-card-inner" style={styles.journeyCard}>
                    <div className="journey-img-wrapper" style={styles.imgWrapper}>
                      <img src={item.img} alt={item.title} className="journey-card-img" style={styles.cardImg} />
                    </div>
                    <div className="p-3 d-flex flex-column h-100">
                      <h6 style={styles.cardTitle}>{item.title}</h6>
                      <div style={styles.locationText}>📍 {item.location}</div>
                      <hr style={{ margin: '10px 0', opacity: 0.15 }} />
                      <ul className="list-unstyled mb-0" style={styles.medalList}>
                        {item.medals.map((m, i) => (
                          <li key={i}>• {m}</li>
                        ))}
                      </ul>
                      {item.note && <small style={styles.noteText}>{item.note}</small>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Right Arrow Button */}
          <button 
            className="nav-btn ms-2 ms-md-3" 
            onClick={handleNext}
            aria-label="Next Slide"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

const styles = {
  journeySection: { backgroundColor: '#ffffff', overflow: 'hidden', fontFamily: "'Poppins', sans-serif" },
  sectionHeading: { 
    fontWeight: '900', 
    color: '#000080',
    letterSpacing: '2px', 
    margin: '0 15px', 
    whiteSpace: 'nowrap',
    fontSize: 'clamp(20px, 4vw, 28px)',
    fontFamily: "'Montserrat', sans-serif",
  },
  headingLineLeft: {
    height: '4px',
    width: '60px',
    backgroundColor: '#ff7700',
    borderRadius: '2px',
  },
  headingLineRight: {
    height: '4px',
    width: '60px',
    backgroundColor: '#008000',
    borderRadius: '2px',
  },
  journeyCard: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.12)',
  },
  imgWrapper: {
    position: 'relative',
    backgroundColor: '#f1f5f9',
  },
  cardImg: {
    width: '100%',
    height: '135px',
    objectFit: 'cover',
    objectPosition: 'top center',
    display: 'block',
  },
  yearBadge: {
    position: 'absolute',
    top: '-14px',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#ffffff',
    fontWeight: '800',
    fontSize: '13px',
    padding: '4px 12px',
    borderRadius: '6px',
    display: 'inline-block',
    zIndex: 2,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    fontFamily: "'Poppins', sans-serif",
  },
  cardTitle: { 
    fontWeight: '800', 
    color: '#0b192c', 
    fontSize: '15px',
    lineHeight: '1.7',
    minHeight: '40px',
    fontFamily: "'Poppins', sans-serif",
  },
  locationText: { 
    fontSize: '14px',
    fontWeight: '700',
    color: '#ff7700',
    marginTop: '4px',
    lineHeight: '1.8',
    fontFamily: "'Poppins', sans-serif",
  },
  medalList: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#000000',
    lineHeight: '2',
    fontFamily: "'Poppins', sans-serif",
  },
  noteText: { 
    fontSize: '12px',
    fontWeight: '600',
    color: '#000000',
    display: 'block', 
    marginTop: '8px',
    lineHeight: '1.8',
    fontFamily: "'Poppins', sans-serif",
  },
};